import React, { createContext, useEffect, useState } from "react";

export const ShopContext = createContext(null);


const getDefaultCart = () => {
    let cart = {}
    for (let index = 0; index < 300+1; index++) {
        cart[index] = 0;
        
    }
    return cart;
}

const ShopContextProvider = (props)=>{

    const [all_product,setAll_Product] = useState([]);


    const [cartItems,setCartItems] = useState(getDefaultCart());

    useEffect(()=>{
        fetch('/api/allproducts').then((response)=>response.json()).then((data)=>setAll_Product(data))
        if (localStorage.getItem('auth-token')) {
            fetch('/api/getcart', {
                method:'POST',
                headers:{
                    Accept:'application/form-dara',
                    'auth-token':`${localStorage.getItem('auth-token')}`,
                    'Content-Type':'application/json',
                },
                body:"",
            }).then((response)=>response.json()).then((data)=>setCartItems(data));
        }
    },[])
    

    const addToCart = (itemId) => {
      const newQty = Number(cartItems[itemId] || 0) + 1;
    
      setCartItems((prev) => ({
        ...prev,
        [itemId]: newQty,
      }));
    
      if (localStorage.getItem('auth-token')) {
        fetch('/api/addtocart', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'auth-token': localStorage.getItem('auth-token'),
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ itemId, quantity: newQty }), // ✅ TELJES mennyiség
        });
      }
    };
    
    
    
    
      
    

      const removeFromCart = (itemId) => {
        setCartItems((prev) => ({
          ...prev,
          [itemId]: Math.max(Number((prev[itemId] || 0)) - 1, 0),
        }));
      
        if (localStorage.getItem('auth-token')) {
          fetch('/api/removefromcart', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'auth-token': localStorage.getItem('auth-token'),
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ itemId }),
          });
        }
      };
      

    const getTotalCartAmount = () => {
        let totalAmount = 0;
        for (const item in cartItems) {
            if (cartItems[item] > 0) {
                const itemInfo = all_product.find((product) => product.id === Number(item));
                if (itemInfo) {
                    totalAmount += itemInfo.price * cartItems[item];
                }
            }
        }
        return totalAmount;
    };
    

    const getTotalCartItems = () => {
        let totalItem = 0;
        for(const item in cartItems)
        {
            if(cartItems[item] > 0)
            {
                totalItem += cartItems[item]
            }
        }
        return totalItem
    }

    const contextValue = { getTotalCartItems, getTotalCartAmount, all_product, setAll_Product, addToCart, removeFromCart, cartItems, setCartItems }
    return (
        <ShopContext.Provider value={contextValue}>
            {props.children}
        </ShopContext.Provider>
    )
}

export default ShopContextProvider